import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { resolver } from "../../../API/middlewares/resolveRequests";
import { getAllLookupByName } from "../../../API/services/utilities";
import AdminHome from "../../admin/adminHome";
import LookupsAlerts from "./lookupsAlerts";
import Lang from "../../../userPreferences/staticWords";
const LookupsManage = ({ selectedLookup, userToken }) => {
  const reload = useSelector((state) => state.reload.reload);
  const [lookupData, setLookupData] = useState([]);
  useEffect(() => {
    if (selectedLookup) {
      resolver(getAllLookupByName, setLookupData, selectedLookup);
    }
  }, [selectedLookup, reload]);
  const [modalVisible, setModalVisible] = useState({
    addLookup: false,
    deleteLookup: false,
    editLookup: false,
    helperData: null,
  });
  return (
    <>
      <LookupsAlerts
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        selectedLookup={selectedLookup}
        userToken={userToken}
      />
      <AdminHome
        title={Lang[selectedLookup]}
        listType={"lookups"}
        data={lookupData}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
      />
    </>
  );
};

export default LookupsManage;
